import type { InjectionKey } from "vue";
import type { AppConfig } from "../app_config_provider";

const API_PATH = "/v4/whoami";

export interface WhoamiDto {
  address_api_token: string;
  api_client_id: number;
}

export const whoamiApiKey: InjectionKey<WhoamiApi> = Symbol("whoami-api");
export class WhoamiApi {
  private readonly config: Pick<AppConfig, "api_url" | "api_token">;

  constructor(config: Pick<AppConfig, "api_url" | "api_token">) {
    this.config = config;
  }

  async getWhoami(
  ): Promise<WhoamiDto | null> {
    const response = await fetch(`${this.config.api_url}${API_PATH}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-API-TOKEN": this.config.api_token,
      },
    });

    if (!response.ok) {
      console.log(`getWhoami: ${response.status} ${response.statusText}`);
      throw new Error('General_Api_Failed')
    }

    return response.json() as Promise<WhoamiDto|null>;
  }
}
